// KOL Report — เส้นที่หน้าเราเรียกเอง (นอกจาก iframe ที่ฝังรายงานของเขาไว้)
//
// ทุกเส้นวิ่งผ่าน relay ของเรา ไม่ยิงตรงจาก browser เพราะโดเมนเขาไม่ตั้ง CORS
// (ดู server/services/relay.service.ts)
import { api } from "@shared/api/client";

export const kolKeys = {
  campaign: (key: string) => ["kol", "campaign", key] as const,
  refresh: (key: string) => ["kol", "refresh", key] as const,
};

export type KolCampaignMeta = {
  key: string;
  name: string;
  rosterCount: number | null;
  /** ครั้งล่าสุดที่ระบบ KOL ไปดึงยอดจาก Apify — null = ยังไม่เคยดึง */
  refreshedAt: string | null;
};

export async function fetchKolCampaign(key: string): Promise<KolCampaignMeta> {
  const { data } = await api.get<KolCampaignMeta>(`/kol/campaigns/${encodeURIComponent(key)}`);
  return {
    key: data?.key ?? key,
    name: data?.name ?? key,
    rosterCount: data?.rosterCount ?? null,
    refreshedAt: data?.refreshedAt ?? null,
  };
}

/** สถานะงานดึงข้อมูลของฝั่ง KOL — รูปร่างตามที่ /report/refresh/status ของเขาคืนมา */
export type KolRefreshStatus = {
  status?: string;
  message?: string;
  posts?: number;
};

export async function startKolRefresh(campaign: string): Promise<void> {
  await api.post(`/kol/refresh?campaign=${encodeURIComponent(campaign)}`);
}

export async function fetchKolRefreshStatus(campaign: string): Promise<KolRefreshStatus> {
  const { data } = await api.get<KolRefreshStatus>(
    `/kol/refresh/status?campaign=${encodeURIComponent(campaign)}`,
  );
  return data ?? {};
}
